import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface TenantState {
  /** The currently-selected tenant ID (used by Platform Admins to scope API calls). */
  selectedTenantId: string | null;

  setSelectedTenantId: (tenantId: string | null) => void;
  clear: () => void;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      selectedTenantId: null,

      setSelectedTenantId: (tenantId) =>
        set({ selectedTenantId: tenantId }),

      clear: () =>
        set({ selectedTenantId: null }),
    }),
    {
      name: 'css-admin-tenant',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        selectedTenantId: state.selectedTenantId,
      }),
    }
  )
);
